import React from 'react';
import { observer } from 'mobx-react';
import { ICartSidebarConfig } from '~exported/CartSidebar/ICartSidebar';
// @ts-ignore
import OfferCodeModuleComponent from 'pg_service_offers/cart-sidebar-offer-code-module';
import { useTranslation } from '../Shared/Providers/Translations/TranslationsHook';

export const OfferCodeModule = observer(({ config }: { config: ICartSidebarConfig }) => (
    <OfferCodeModuleComponent config={config} translations={useTranslation()} />
));
